import imageOne from '@/assets/images/cities/mississauga1.jpg'
import imageTwo from '@/assets/images/cities/mississauga2.jpg'
import imageThree from '@/assets/images/cities/mississauga3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Mississauga',
  writeup:
    'We offer Mississauga’s premier Notary Public and Commissioner for Oaths services at affordable prices. Our services are provided by trusted and respected lawyers who are members of the Law Society of Upper Canada. From certified copies to attestations, we offer a wide variety of services to meet your needs. Our office is open late on weekdays (up to 6:00 PM) and is open on Saturdays to help accommodate your busy schedule!<br><br>All Notary Services are by appointment only.  Call us today to book a time to see us!<br><br>Any questions or concerns? Give us a call, our staff are ready to help! We take pride in our friendly service and work diligently to meet your needs.',
  website: 'NotaryPublicInMississauga.com',
  url: 'https://www.notarypublicinmississauga.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '(647) 795-2772',
      hours: {
        monday: '11:00AM to 6:00PM',
        tuesday: '11:00AM to 6:00PM',
        wednesday: '11:00AM to 6:00PM',
        thursday: '11:00AM to 6:00PM',
        friday: '11:00AM to 6:00PM',
        saturday: '12:00PM to 4:00PM',
        sunday: ''
      },
      address: '25 Watline Avenue Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontarioGTA/cities/mississauga.js